import {combineReducers} from 'redux';
import {getUsersReducer} from './getUsers'
import {addSessionReducer } from './addSessionRed';
import {getUserCreateInvoceFilesReducer} from './getUserFiles'
const reducer = combineReducers({
   addSessionReducer,getUsersReducer,getUserCreateInvoceFilesReducer 
    });
    
    export default reducer;
